import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'
import { MButton, TextInput } from 'components'
import { MESSAGES } from 'config/projectConstants'
import { useSnackbar } from 'notistack'
import type React from 'react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { APIs } from 'services/apis'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import * as yup from 'yup'
import { type InformationFormType } from './ServiceForm'

const schema = yup
    .object({
        accountId: yup.string().required('Account number is a required field'),
        lastName: yup.string().required('Last name is a required field')
    })
    .required()

interface UserValidationFormProps {
    handleNext: () => void
    handleBack: () => void
    formData: InformationFormType
    setFormData: (data: InformationFormType) => void
}

export interface UserValidationFormType {
    accountId: string
    lastName: string
}

const UserValidationForm: React.FC<UserValidationFormProps> = ({
    handleNext,
    handleBack,
    setFormData,
    formData

}: UserValidationFormProps) => {
    const isMobile = useMobileBreakpoints()
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState<boolean>(false)
    const {
        handleSubmit,
        control,
        formState: { errors }
    } = useForm<UserValidationFormType>({
        mode: 'all',
        defaultValues: {
            accountId: '',
            lastName: ''
        },
        resolver: yupResolver(schema)
    })


    const onSubmit = async (body: UserValidationFormType): Promise<void> => {
        setLoading(true)
        try {
            const response = await APIs.verifyPayBill(body)
            if (response.success === true) {
                handleNext()
                setFormData({ ...formData, lastName: body.lastName, accountId: body.accountId })
            } else {
                enqueueSnackbar(MESSAGES.VERIFY_PAY_BILL_ERROR_TEMP, { variant: 'error' })
            }
        } catch (error) {
            enqueueSnackbar(MESSAGES.VERIFY_PAY_BILL_ERROR_TEMP, { variant: 'error' })
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box>
            <TextInput
                fieldLabel="Account number"
                fieldName="accountId"
                fieldType="text"
                placeholder="Enter your account number"
                control={control}
                errors={errors}
            />
            <TextInput
                fieldLabel="Last name"
                fieldName="lastName"
                fieldType="text"
                placeholder="Enter your last name"
                control={control}
                errors={errors}
            />
            <Box
                display="flex"
                my={6}
                width={isMobile ? '100%' : '50%'}
                flexDirection={isMobile ? 'column' : 'row'}
                gap={2}
            >
                <MButton
                    fullWidth
                    variant="outlined"
                    texttransform="none"
                    rounded="true"
                    onClick={() => {
                        handleBack()
                    }}
                >
                    Back
                </MButton>
                <MButton
                    fullWidth
                    variant="contained"
                    type="submit"
                    texttransform="none"
                    rounded="true"
                    loading={loading}
                    disabled={loading}
                    onClick={handleSubmit(onSubmit)}
                >
                    Validate Account
                </MButton>
            </Box>
        </Box>
    )
}

export default UserValidationForm
